import Vue from 'vue'

/**
 * Here, we take all of the independent
 * Vuex modules laid out in the store
 * subdirectories and create a single Vuex
 * store that includes all of them.
 */
export default el => Promise.all([
  enqueueModule('cookies-notice')
]).then(() => new Vue({ el }))
